import { render, staticRenderFns } from "./FourOfour.vue?vue&type=template&id=2ccebfca&scoped=true&"
import script from "./FourOfour.vue?vue&type=script&lang=js&"
export * from "./FourOfour.vue?vue&type=script&lang=js&"
import style0 from "./FourOfour.vue?vue&type=style&index=0&id=2ccebfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccebfca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VLayout})
